import { alpha } from '@mui/material/styles';
import {
  gray,
  orange,
  brand,
  red,
  green,
} from '../themePrimitives';

/* eslint-disable import/prefer-default-export */
export const feedbackCustomizations = {
  MuiAlert: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 10,
        borderWidth: 1,
        borderStyle: 'solid',
        '&.MuiAlert-standardSuccess': {
          backgroundColor: alpha(green[100], 0.6),
          borderColor: alpha(green[400], 0.7),
          color: green[700],
          '& .MuiAlert-icon': { color: green[600] },
          ...theme.applyStyles('dark', {
            backgroundColor: alpha(green[900], 0.4),
            borderColor: alpha(green[700], 0.6),
            color: green[200],
          }),
        },
        '&.MuiAlert-standardError': {
          backgroundColor: alpha(red[100], 0.6),
          borderColor: alpha(red[400], 0.7),
          color: red[700],
          '& .MuiAlert-icon': { color: red[500] },
          ...theme.applyStyles('dark', {
            backgroundColor: alpha(red[900], 0.4),
            borderColor: alpha(red[700], 0.6),
            color: red[100],
          }),
        },
        '&.MuiAlert-standardWarning': {
          backgroundColor: alpha(orange[100], 0.7),
          borderColor: alpha(orange[300], 0.6),
          color: orange[700],
          '& .MuiAlert-icon': { color: orange[500] },
          ...theme.applyStyles('dark', {
            backgroundColor: alpha(orange[900], 0.4),
            borderColor: alpha(orange[700], 0.6),
            color: orange[100],
          }),
        },
        '&.MuiAlert-standardInfo': {
          backgroundColor: alpha(brand[100], 0.6),
          borderColor: alpha(brand[300], 0.6),
          color: brand[700],
          '& .MuiAlert-icon': { color: brand[500] },
          ...theme.applyStyles('dark', {
            backgroundColor: alpha(brand[900], 0.4),
            borderColor: alpha(brand[700], 0.6),
            color: brand[100],
          }),
        },
      }),
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          border: '1px solid',
          borderColor: (theme.vars || theme).palette.divider,
        },
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 8,
        borderRadius: 8,
        backgroundColor: gray[200],
        ...theme.applyStyles('dark', { backgroundColor: gray[800] }),
      }),
    },
  },
};
